import React from 'react';
import { Interp, css, toList } from '../../lib/render.jsx';
import { Kruis } from '../Iconen.jsx';

export default function Inbox({ v }) {
  if (!v.showInbox) return null;
  return (
    <>
      {' '}
      <div style={css(v.inboxOverlayStyle)} onClick={v.closeDialog}>
        {' '}
        <div onClick={v.stopProp} style={css(v.inboxModalStyle)}>
          {' '}
          <div style={css(v.inboxHeaderStyle)}>
            {' '}
            {' '}
            <div style={css(v.inboxTitleStyle)}>
              Postvakje
            </div>
            {' '}
            <button onClick={v.closeDialog} title="Sluiten" style={css(v.sluitStyle)}>
              <Kruis maat={20} />
            </button>
            {' '}
          </div>
          {' '}
          <div style={css(v.inboxBodyStyle)}>
            {' '}
            {v.reqEmpty ? (<>
              {' '}
              <div style={{ "fontSize": "13px", "fontWeight": "600", "color": "var(--tekst-3)", "lineHeight": "1.4", "border": "3px dashed var(--rand-stippel)", "borderRadius": "12px", "padding": "16px", "textAlign": "center", "flex": "0 0 auto" }}>
                <Interp v={v.reqEmptyLabel} />
              </div>
              {' '}
            </>) : null}
            {' '}
            {v.hasReqError ? (<>
              {' '}
              <div style={{ "fontSize": "13px", "color": "var(--fout)", "fontWeight": "600", "flex": "0 0 auto" }}>
                <Interp v={v.reqError} />
              </div>
              {' '}
            </>) : null}
            {' '}
            <div style={css(v.inboxListStyle)}>
              {' '}
              {toList(v.reqFeed).map((r, $index) => (
                <React.Fragment key={$index}>
                  {' '}
                  <div style={css(r?.rowStyle)}>
                    {' '}
                    <div style={{ "display": "flex", "flexDirection": "column", "gap": "8px", "minWidth": "0" }}>
                      <div style={{ "display": "flex", "alignItems": "center", "gap": "7px", "minWidth": "0" }}>
                        <img alt="" src={r?.avatarUrl} style={{ "width": "26px", "height": "26px", "imageRendering": "pixelated", "border": "2px solid var(--ink)", "borderRadius": "8px", "background": "#fff", "display": "block", "flex": "0 0 auto" }} />
                        <span style={{ "fontSize": "13px", "fontWeight": "700", "overflow": "hidden", "textOverflow": "ellipsis", "whiteSpace": "nowrap" }}>
                          <Interp v={r?.who} />
                        </span>
                        {r?.hasTarget ? (<>
                          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="var(--tekst-3)" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" style={{ "flex": "0 0 auto" }}>
                            <path d="M5 12h14" />
                            <path d="m13 6 6 6-6 6" />
                          </svg>
                          <img alt="" src={r?.targetAvatarUrl} style={{ "width": "26px", "height": "26px", "imageRendering": "pixelated", "border": "2px solid var(--ink)", "borderRadius": "8px", "background": "#fff", "display": "block", "flex": "0 0 auto" }} />
                          <span style={{ "fontSize": "13px", "fontWeight": "700", "overflow": "hidden", "textOverflow": "ellipsis", "whiteSpace": "nowrap" }}>
                            <Interp v={r?.targetName} />
                          </span>
                        </>) : null}
                        <span style={css(r?.tagStyle)}>
                          <Interp v={r?.tag} />
                        </span>
                      </div>
                      <div style={css(r?.textStyle)}>
                        <Interp v={r?.text} />
                      </div>
                    </div>
                    {' '}
                    {r?.hasActions ? (<>
                      {' '}
                      <div style={{ "display": "flex", "gap": "8px", "flex": "0 0 auto", "width": "100%" }}>
                        {r?.canDraw ? (<>
                          <button onClick={r?.onDraw} className="gp-btn" style={{ "flex": "1 1 auto", "justifyContent": "center", "height": "auto", "fontSize": "13px", "padding": "8px 13px", "background": "var(--paars)", "color": "#fff", "whiteSpace": "nowrap" }}>
                            Ik teken deze!
                          </button>
                        </>) : null}
                        {r?.canDecline ? (<>
                          <button onClick={r?.onDecline} className="gp-btn" title="Verzoekje weigeren" style={{ "flex": "0 0 auto", "justifyContent": "center", "height": "auto", "fontSize": "12px", "padding": "8px 13px", "background": "#fff", "whiteSpace": "nowrap" }}>
                            Nee, sorry
                          </button>
                        </>) : null}
                        {r?.canCancel ? (<>
                          <button onClick={r?.onCancel} className="gp-btn" title="Je verzoekje intrekken" style={{ "flex": "1 1 auto", "justifyContent": "center", "height": "auto", "fontSize": "12px", "padding": "8px 13px", "background": "#fff", "whiteSpace": "nowrap" }}>
                            Intrekken
                          </button>
                        </>) : null}
                      </div>
                      {' '}
                    </>) : null}
                    {' '}
                  </div>
                  {' '}
                </React.Fragment>
              ))}
              {' '}
            </div>
            {' '}
            <button onClick={v.naarVerzoek} className="gp-btn pink" style={css(v.naarVerzoekStyle)}>
              Nieuw verzoekje
            </button>
            {' '}
          </div>
          {' '}
        </div>
        {' '}
      </div>
      {' '}
    </>
  );
}
